/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Ask_Source_DescInputs */

const en_ui_onboarding_ask_source_desc = /** @type {(inputs: Ui_Onboarding_Ask_Source_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`intervals.icu, FIT files or demo data`)
};

const de_ui_onboarding_ask_source_desc = /** @type {(inputs: Ui_Onboarding_Ask_Source_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`intervals.icu, FIT-Dateien oder Demodaten`)
};

/**
* | output |
* | --- |
* | "intervals.icu, FIT files or demo data" |
*
* @param {Ui_Onboarding_Ask_Source_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_ask_source_desc = /** @type {((inputs?: Ui_Onboarding_Ask_Source_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Ask_Source_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_ask_source_desc(inputs)
	return de_ui_onboarding_ask_source_desc(inputs)
});